import * as api from '../requests'
import store, { history } from '../store'
import ls from 'local-storage'
import shortid from 'shortid'
import { resetFullAppState, getAndSetCartQuantity, toggleLoginModal } from '../actions'

////////////////////////
/////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
//////////

///////////////////////////
/////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
//////////

export const loginWebUser = (credentials, callback) => (dispatch) => {
  api.LOGIN_WEB_USER(
    credentials,
    (response) => {
      storeAndDispatchLoginResponse(response, dispatch)
      dispatch(getAndSetCartQuantity())
      // dispatch(registerAuthPoll())
      callback(true)
    },
    (err) => {
      // if(err.code === 'auth/invalidLogin')
      callback(
        false,
        err.message || 'The username or password you provided was incorrect. Please try again.'
      )
    }
  )
}

// Case-tolerant field read: the signed-in user payload arrives PascalCase (legacy monolith /
// the /api/Auth/callback proxy) or camelCase (identity microservice). Read both so an upstream
// casing change can't blank out the user — the My Account button reads USERNAME/FIRST_NAME from
// auth state, and a missing USERNAME crashed its render, so it vanished for hosted-login users
// (the identity-myaccount-btn hotfix worked around exactly this). Companion to the bug-74275
// envelope tolerance below.
const pickField = (obj, ...keys) => {
  if (!obj) return undefined
  for (const k of keys) {
    if (obj[k] !== undefined && obj[k] !== null) return obj[k]
  }
  return undefined
}

export const storeAndDispatchLoginResponse = (response, dispatch) => {
  let user;
  let userAuthentication;

  if (response.User) {
    user = response.User;
  } else if (response.LoggedInUser) {
    user = response.LoggedInUser;
  }

  if (response.Auth) {
    userAuthentication = response.Auth
  } else if (response.Value) {
    userAuthentication = {
        ID: response.ID,
        Value: response.Value
    }
  }

  localStorage.setItem('USER', JSON.stringify(user))
  localStorage.setItem('USER_AUTHENTICATION', JSON.stringify(userAuthentication))

  const userRights = pickField(user, 'Rights', 'rights') || []
  const loginObj = {
    initialAuthCheck: false,
    FIRST_NAME: pickField(user, 'FirstName', 'firstName'),
    MIDDLE_NAME: pickField(user, 'MiddleName', 'middleName'),
    LAST_NAME: pickField(user, 'LastName', 'lastName'),
    BUSINESS_NAME: pickField(user, 'BusinessName', 'businessName'),
    ORG_NAME: pickField(user, 'OrgName', 'orgName'),
    WEB_USER_ID: pickField(user, 'UserId', 'userId'),
    USERNAME: pickField(user, 'Username', 'username'),
    USER_GROUP: userRights,
    isFrequentPayor: pickField(user, 'IsFrequentPayor', 'isFrequentPayor'),
    EMAIL: pickField(user, 'Email', 'email'),
    rights: userRights,
    roles: pickField(user, 'Roles', 'roles'),
    loggedIn: true,
    trigger: shortid.generate(),
    PHONE: pickField(user, 'Phone', 'phone'),
    appUserRights: userRights.map((right) => right.Name || right.name),
  }
  dispatch(spreadAuthAttributes(loginObj))
  const cachedCategory = getCategoryCache(user.UserId)
  if (cachedCategory) {
    dispatch({ type: 'SET_CURRENT_CATEGORY', category: cachedCategory })
  }
  dispatch(getAndSetCartQuantity())
  ls.set('EVENT_LOGIN', loginObj)
}

const getCategoryCache = (WEB_USER_ID) => {
  const userCache = ls.get('USER_CACHE')
  if (userCache) {
    return userCache[WEB_USER_ID]
  }
}

export const spreadAuthAttributes = (payload) => ({
  type: 'SPREAD_AUTH_ATTRIBUTES',
  payload,
})

export const setAuthAttribute = (attribute, value) => ({
  type: 'SET_AUTH_ATTRIBUTE',
  attribute,
  value,
})

export const setAppUserID = (appUserID) => ({
  type: 'SET_APP_USER_ID',
  appUserID,
})

export const getAuthState = (callback) => (dispatch, getState) => {
  dispatch(setAuthAttribute('checkingAuthState', true))
  let WEB_USER = localStorage.getItem('USER')
  let webUser = WEB_USER && WEB_USER !== 'undefined' ? JSON.parse(WEB_USER) : {}
  api.GET_AUTH_STATE(
    (response) => {
      // console.log({ response, webUser })
      if (response !== false && response !== 'false') {
        if (callback) {
          callback(true, dispatch)
        }

        const loggedInUser = {
            ...(response.loggedInUser && response.loggedInUser !== undefined ? response.loggedInUser :
                (response.LoggedInUser && response.LoggedInUser !== undefined ? response.LoggedInUser : {})
            )
        };

        const webUserRights = pickField(webUser, 'Rights', 'rights') || []
        const authObj = {
          ...loggedInUser,
          checkingAuthState: false,
          loggedIn: true,
          FIRST_NAME: pickField(webUser, 'FirstName', 'firstName'),
          MIDDLE_NAME: pickField(webUser, 'MiddleName', 'middleName'),
          LAST_NAME: pickField(webUser, 'LastName', 'lastName'),
          BUSINESS_NAME: pickField(webUser, 'BusinessName', 'businessName'),
          WEB_USER_ID: pickField(webUser, 'UserId', 'userId'),
          USERNAME: pickField(webUser, 'Username', 'username'),
          isFrequentPayor: pickField(webUser, 'IsFrequentPayor', 'isFrequentPayor'),
          initialAuthCheck: false,
          trigger: shortid.generate(),
          EMAIL: pickField(webUser, 'Email', 'email'),
          PHONE: pickField(webUser, 'Phone', 'phone'),
          rights: webUserRights,
          roles: pickField(webUser, 'Roles', 'roles'),
          appUserRights: webUserRights.map((right) => right.Name || right.name),
        }
        // console.log(authObj)
        dispatch(spreadAuthAttributes(authObj))

        // If our web user has nothing, then we dispatch a login
        // response to get our user stored before continuing.
        if (Object.keys(webUser).length === 0) {
            storeAndDispatchLoginResponse(response, dispatch);
        }

        let location = getState().router.location
        if (location.pathname === '/auth' || location.pathname === '/admin') {
          const from = location.search
            ? new RegExp(/from=(.*?)(&|$)/g).exec(location.search) || []
            : '/'
          const search = location.search
            ? new RegExp(/search=(.*?)$/g).exec(location.search) || []
            : '/'
          history.replace(`${from[1] || ''}${search[1] || ''}`)
        }
        // dispatch(registerAuthPoll())
        ls.set('EVENT_LOGIN', authObj)
        if (process.env.SHOPPING_CART) {
          dispatch(getAndSetCartQuantity())
        }
      } else {
        if (callback) {
          callback(false, dispatch)
        }
        dispatch(
          spreadAuthAttributes({
            checkingAuthState: false,
            initialAuthCheck: false,
            loggedIn: false,
          })
        )
        dispatch(clearUser())
        // unregisterAuthPoll()
      }
    },
    (err) => {
      dispatch(
        spreadAuthAttributes({
          checkingAuthState: false,
          initialAuthCheck: false,
          loggedIn: false,
        })
      )
      dispatch(clearUser())
    }
  )
}

export const registerAuthPoll = () => (dispatch) => {
  if (!window.AUTH_POLL) {
    window.AUTH_POLL = setInterval(() => {
      dispatch(getAuthState())
    }, 60000)
  }
}

export const unregisterAuthPoll = () => {
  clearInterval(window.AUTH_POLL)
  delete window.AUTH_POLL
}

export const clearUser = () => ({
  type: 'CLEAR_USER',
})

export const logoutWebUser = (broadcast) => (dispatch) => {
  if (process.env.RETURN_TO_HOME_ON_LOGOUT) {
    history.push('/')
  }
  api.LOGOUT_WEB_USER((response) => {
    if (response === true) {
      clearLocalUser(broadcast)
      detachEventCheck()
      ls.set('EVENT_LOGOUT', shortid.generate())
      if (process.env.LOGIN_REDIRECTS_TO_EPASS) {
        logoutEpassUser()
      }
    }
  })
}

export const logoutEpassUser = () => {
  window.location.href = `${api.BASE_URL}/api/Logout.epass`
}

export const clearLocalUser = (broadcast) => {
  window.ALLOW_BYPASS_WIZARD_PROMPT = true
  localStorage.removeItem('USER')
  localStorage.removeItem('USER_AUTHENTICATION')
  localStorage.setItem('AUTH_TIMER', 0)
//////////////////////////
///////////////////////////////////
/////////////////////////////////////////////////////////
/////////////////////////
////////////////////////////////////////////////
////////////////////////////
/////
///
////////////
/////////////////////////////
////////////////////////////////
//////////////////////////////////////////////////////////

/////////////////////////
//////////////////////////////////////////////////////
//////////////////////////////////
/////
///
////////////
  if (process.env.HAS_KEYSTONE_LOGIN) {
    const userIsLoggedIn = store.getState().auth.loggedIn
    if (userIsLoggedIn) {
      localStorage.removeItem('KEYSTONE_RETURN_URL')
      history.replace('/')
    }
  }
  clearLocalUserState()
  if (broadcast) {
    ls.set('EVENT_LOGOUT', shortid.generate())
  }
  window.ALLOW_BYPASS_WIZARD_PROMPT = false
}

const clearLocalUserState = () => {
  clearTimeout(window.AUTH_TIMER)
  window.AUTH_TIMER = null
  clearTimeout(window.EVENT_CHECK_TIMER)
  window.EVENT_CHECK_TIMER = null
  store.dispatch(clearUser())
  store.dispatch(resetFullAppState())
  if(store.getState().router.location.pathname !== '/auth'){
    store.dispatch(toggleLoginModal(true))
  }
}

export const loginAppUser = (credentials, callback) => (dispatch) => {
  api.LOGIN_APP_USER(
    credentials,
    (response) => {
      storeAndDispatchLoginResponse(response, dispatch)
      dispatch(getAndSetCartQuantity())
      callback(true)
    },
    (err) => {
      callback(false, err.message || 'Invalid Login')
    }
  )
}

export const loginActiveDirectoryUser = (accessToken, callback) => (dispatch) => {
  api.ND_STATE_USER_GET(
    accessToken,
    (response) => {
      storeAndDispatchLoginResponse(response, dispatch);
      dispatch(getAndSetCartQuantity());
      callback(true);
    }, (err) => {
      callback(false, err.message || 'Invalid Login');
    }
  );
}

export const loginB2CUser = (idToken, callback) => (dispatch) => {
  api.ND_PUBLIC_USER_GET(
    idToken,
    (response) => {
      storeAndDispatchLoginResponse(response, dispatch);
      dispatch(getAndSetCartQuantity());
      callback(true);
    }, (err) => {
      callback(false, err.message || 'Invalid Login');
    }
  );
}

export const setExpiration = (expires) => ({
  type: 'SET_EXPIRATION',
  expires,
})

export const extendUserSession = () => (dispatch) => {
  dispatch(setExpiration(null))
  let staleToken = '';

//////////////////////////
////////////////////////////////////////////
//////////////////////////////////
////////////////////////////////////////////////////////
////
////////////
  detachEventCheck()
//////////////////////////
  api.EXTEND_WEB_USER_SESSION(null, () => {})
////////////
}

const handleAuthTimeout = () => {
  store.dispatch(setExpiration(30))
}

const handleUserAction = () => {
  detachEventCheck()
  store.dispatch(extendUserSession())
}

export const detachEventCheck = () => {
  document.removeEventListener('click', handleUserAction)
  document.removeEventListener('keydown', handleUserAction)
  document.removeEventListener('mousemove', handleUserAction)
}

export const attachEventCheck = () => {
  document.addEventListener('click', handleUserAction)
  document.addEventListener('keydown', handleUserAction)
  document.addEventListener('mousemove', handleUserAction)
}

const setAuthTimers = (paddedTimeout, eventCheckTimeout) => {
  store.dispatch(setExpiration(null))
  clearTimeout(window.AUTH_TIMER)
  clearTimeout(window.EVENT_CHECK_TIMER)
  window.AUTH_TIMER = window.setTimeout(handleAuthTimeout, paddedTimeout)
  if (eventCheckTimeout > 0) {
    window.EVENT_CHECK_TIMER = window.setTimeout(attachEventCheck, eventCheckTimeout)
  }
  localStorage.setItem('AUTH_TIMEOUT', paddedTimeout)
}

export const setAuthTimeout = (timeout) => {
  const paddedTimeout = timeout - 60000
  const eventCheckTimeout = paddedTimeout - 300000
  if (paddedTimeout > 0) {
    setAuthTimers(paddedTimeout, eventCheckTimeout)
    ls.set('EVENT_SET_TIMEOUT', { paddedTimeout, eventCheckTimeout, trigger: shortid.generate() })
  }
}

ls.on('EVENT_SET_TIMEOUT', (value) => {
  detachEventCheck()
  setAuthTimers(value.paddedTimeout, value.eventCheckTimeout)
})

ls.on('EVENT_LOGIN', (value) => {
  store.dispatch(spreadAuthAttributes(value))
})

ls.on('EVENT_LOGOUT', () => {
  detachEventCheck()
  clearLocalUserState()
})

export const skipAuthCheck = () => (dispatch) => {
  dispatch(
    spreadAuthAttributes({
      initialAuthCheck: false,
    })
  )
}
